module.exports = __webpack_public_path__ + "static/androidBannerMakingMatsBig-88d750ac4c3e5c911326d0ce03617e6c.png";